import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppShell } from "@/components/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Bausteine from "@/pages/Bausteine";
import InvoiceEditor from "@/pages/InvoiceEditor";

const Shell = ({ children }) => (
  <ProtectedRoute>
    <AppShell>{children}</AppShell>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="bottom-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/rechnungen" element={<Shell><Dashboard /></Shell>} />
            <Route path="/bausteine" element={<Shell><Bausteine /></Shell>} />
            <Route path="/editor" element={<Shell><InvoiceEditor /></Shell>} />
            <Route path="/editor/:id" element={<Shell><InvoiceEditor /></Shell>} />
            <Route path="/" element={<Navigate to="/rechnungen" replace />} />
            <Route path="*" element={<Navigate to="/rechnungen" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
